if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        console.log('[CartDrawer Debug] onSubmitHandler fired');
        console.log('[CartDrawer Debug] this.cart:', this.cart);
        console.log('[CartDrawer Debug] this.cart tagName:', this.cart ? this.cart.tagName : 'null');
        console.log('[CartDrawer Debug] cart-drawer.js loaded?', typeof customElements.get('cart-drawer'));

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.section || section.id);
          console.log('[CartDrawer Debug] sections being sent:', sections);
          formData.append(
            'sections',
            sections
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

       // PASTE THIS ENTIRE BLOCK TO REPLACE YOUR EXISTING 'fetch'
// PASTE THIS NEW DIAGNOSTIC BLOCK
console.log('--- ATC START ---');
fetch(`${routes.cart_add_url}`, config)
  .then((response) => {
    console.log('1. Fetch responded. Status:', response.status);
    // Clone the response so we can read it twice (once as text, once as json)
    return response.clone().json().catch(() => response.text());
  })
  .then((response) => {
    console.log('2. Parsed response:', response);

    if (response.status) {
      console.log('3. ERROR DETECTED by Shopify API (response.status). Description:', response.description);
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        errors: response.errors || response.description,
        message: response.message,
      });
      this.handleErrorMessage(response.description);
      this.error = true;
      return;
    } else if (!this.cart) {
      console.log('No cart drawer found, redirecting...');
      window.location = window.routes.cart_url;
      return;
    }

    this.error = false;
    // MODIFICATION: Add a clear log before rendering
    if (response.sections) {
      console.log('3. SUCCESS: Response contains sections. Calling renderContents...');
      this.cart.renderContents(response);
      console.log('4. renderContents has been called.');
    } else {
      console.log('3. ERROR: Response is missing "sections". Cart will not be updated.');
      this.error = true;
      this.handleErrorMessage('There was an issue updating the cart. Please try again.');
    }
  })
  .catch((e) => {
    console.error('--- FETCH FAILED ---', e);
    this.error = true;
    this.handleErrorMessage('Request failed. Please check your connection and try again.');
  })
  .finally(() => {
    console.log('5. Finally block executing. Error status:', this.error);
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
    console.log('--- ATC END ---');
  });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
